function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "social-instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    className: "social-circle",
    style: {
      fill: "transparent"
    },
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    className: "social-icon",
    d: "M22,11c-3,0-3.36,0-4.54.07a8.11,8.11,0,0,0-2.67.51,5.62,5.62,0,0,0-3.22,3.22,8.08,8.08,0,0,0-.51,2.67C11,18.64,11,19,11,22s0,3.36.07,4.53a8.08,8.08,0,0,0,.51,2.67,5.62,5.62,0,0,0,3.22,3.22,8.11,8.11,0,0,0,2.67.51C18.64,33,19,33,22,33s3.36,0,4.54-.07a8.11,8.11,0,0,0,2.67-.51,5.62,5.62,0,0,0,3.22-3.22,8.11,8.11,0,0,0,.51-2.67C33,25.36,33,25,33,22s0-3.36-.07-4.53a8.11,8.11,0,0,0-.51-2.67,5.62,5.62,0,0,0-3.22-3.22,8.11,8.11,0,0,0-2.67-.51C25.36,11,25,11,22,11Zm0,2c2.94,0,3.29,0,4.45.06a6.07,6.07,0,0,1,2,.38,3.64,3.64,0,0,1,2.09,2.09,6.07,6.07,0,0,1,.38,2C31,18.72,31,19.06,31,22s0,3.28-.06,4.45a6.07,6.07,0,0,1-.38,2,3.64,3.64,0,0,1-2.09,2.09,6.07,6.07,0,0,1-2,.38C25.29,31,24.94,31,22,31s-3.29,0-4.45-.06a6.07,6.07,0,0,1-2-.38,3.64,3.64,0,0,1-2.09-2.09,6.07,6.07,0,0,1-.38-2C13,25.29,13,24.94,13,22s0-3.28.06-4.45a6.07,6.07,0,0,1,.38-2,3.64,3.64,0,0,1,2.09-2.09,6.07,6.07,0,0,1,2-.38C18.71,13,19.06,13,22,13Zm0,3.37A5.65,5.65,0,1,0,27.65,22v0h0A5.65,5.65,0,0,0,22,16.35Zm0,9.32A3.67,3.67,0,1,1,25.67,22h0A3.67,3.67,0,0,1,22,25.67Zm7.19-9.54a1.32,1.32,0,1,1-1.32-1.32h0A1.32,1.32,0,0,1,29.19,16.15Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.94a938c11f419f0977ac19cd22e208b7.svg";
export { ForwardRef as ReactComponent };